import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../components/Layout.vue'
import Home from '../views/Home.vue'
import ResourceDetail from '../views/ResourceDetail.vue'
import Login from '../views/Login.vue'
import WechatCallback from '../views/WechatCallback.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Home
      },
      {
        path: '/login',
        name: 'Login',
        component: Login
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('../views/Register.vue')
      },
      {
        path: '/resource/:id',
        name: 'ResourceDetail',
        component: ResourceDetail
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/Profile.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/submit',
        name: 'Submit',
        component: () => import('../views/SubmitResource.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/membership',
        name: 'Membership',
        component: () => import('../views/Membership.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/membership-manage',
        name: 'MembershipManage',
        component: () => import('../views/MembershipManage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },
  // 微信登录回调页面（不使用Layout布局）
  {
    path: '/wechat-callback',
    name: 'WechatCallback',
    component: WechatCallback
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // 路由切换时滚动行为
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器后退/前进），返回到该位置
    if (savedPosition) {
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

// 路由守卫 - 检查登录状态
router.beforeEach((to, from, next) => {
  console.log('路由守卫触发:', { from: from.path, to: to.path })
  const token = localStorage.getItem('token')
  
  if (to.meta.requiresAuth && !token) {
    console.log('需要认证但未登录，跳转到登录页')
    // 需要登录但未登录，跳转到登录页
    if (from.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  } else {
    console.log('路由守卫允许通过')
    next()
  }
})

export default router
